export class TelemetryAcceptedCoins {
  constructor(ca11) {
    this.ValueOfAcceptedCoin = Telemetry.setValue(ca11[1]);
    this.NumberOfCoinsInSinceLastReset = Number(ca11[2]);
    this.NumberOfCoinsToCashBoxSinceLastReset = Number(ca11[3]);
    this.NumberOfCoinsToTubesSinceLastReset = Number(ca11[4]);
    this.NumberOfCoinsInSinceInit = Number(ca11[5]);
    this.NumberOfCoinsToCashBoxSinceInit = Number(ca11[6]);
  }
}

export class TelemetryCashlessItem {
  constructor(da7) {
    this.UserGroupNumber = Number(da7[1]);
    this.UserGroupNetSalesSinceLastReset = Number(da7[2]);
    this.UserGroupValueAddedToCashlessSinceLastReset = da7[3];
    this.UserGroupDiscountsSinceLastReset = Number(da7[4]);
    this.NumberOfProductsSoldToCashlessUserGroupsinceInit = Number(da7[5]);
    this.NumberOfProductsSoldToCashlessUserGroupSinceLastReset = Number(da7[6]);
    this.UserGroupNetSalesSinceInit = Number(da7[7]);
  }
}

export class TelemetryCoinTypes {
  constructor(ca17) {
    this.CoinTypeNumberPerMdbCoinTube = Number(ca17[1]);
    this.ValueOfCoin = Telemetry.setValue(ca17[2]);
    this.NumberOfCoinsinTube = Number(ca17[3]);
    this.NumberOfCoinsinsertedDuringControlledManualFill = Number(ca17[4]);
    this.NumberOfCoinsDispensedDuringControlledManualInvent = Number(ca17[5]);
  }
}

export class TelemetryPriceList {
  constructor(la) {
    this.PricelistNumber = Number(la[1]);
    this.ProductNumber = Number(la[2]);
    this.Price = Telemetry.setValue(la[3]);
    this.NumberOfVendsSinceLastReset = Number(la[4]);
    this.NumberOfVendsSinceInit = Number(la[4]);
  }
}

export class TelemetryProduct {
  constructor(idx, pa1, device) {
    this.Identifier = Number(pa1[1]);
    this.Name = device.TelemetryProducts[idx];
    if (this.Name === undefined) {
      this.Name = "P " + this.Identifier;
      device.TelemetryProducts.push(this.Name);
    }
    this.Price = Telemetry.setValue(pa1[2]);
    this.Identification = pa1[3];
    this.MaximumProductCapacity = pa1[4] ? Number(pa1[4]) : 0;
    this.StandardFillingLevel = pa1[5];
    this.StandardDispensedQuantity = pa1[6];
    this.SelectionStatus = pa1[7];
    this.NumberOfPaidProductsVendedSinceInit = 0;
    this.ValueOfPaidProductSalesSinceInit = 0;
    this.NumberOfPaidProductsVendedSinceLastReset = 0;
    this.ValueOfPaidProductSalesSinceLastReset = 0;
    this.NumberOfDiscountedPaidVendsSinceInit = 0;
    this.ValueOfDiscountsGivenSinceInit = 0;
    this.NumberOfDiscountedPaidVendsSinceLastReset = 0;
    this.ValueOfDiscountsGivenSinceLastReset = 0;
  }
}

export class TelemetryIngredient {
  constructor(idx, sa2, device) {
    this.Identifier = Number(sa2[1]);
    try {
      this.Name = device.TelemetryIngredients[idx];
    } catch {
      this.Name = "I " + this.Identifier;
      device.TelemetryIngredients.push(this.Name);
    }
    this.QuantitySinceLastReset = Number(sa2[2]);
    this.QuantitySinceInit = Number(sa2[3]);
  }
}

export class TelemetrySchedule {
  constructor(prms) {
    if (prms) {
      this.Values = [...prms];
    } else {
      this.Values = [];
    }
  }
  toString() {
    return Object.values(this.Values)
      .filter((f) => f)
      .sort()
      .join(", ");
  }
}

export class Telemetry {
  static setValue(val) {
    return (Number(val) / Telemetry.DecimalDivider).roundTo(2);
  }
  static DecimalDivider = 1;

  /**
   *
   * @param {Telemetry} telemetry1
   * @param {Telemetry} telemetry2
   */
  static ComputeTelemetry(telemetry1, telemetry2) {
    var t0 = Object.assign({}, telemetry1);
    t0.DatePeriodStart = telemetry2.Date;
    t0.Ingredients.forEach((i, idx) => {
      i.QuantitySinceInit = telemetry1.Ingredients[idx].QuantitySinceInit - telemetry2.Ingredients[idx].QuantitySinceInit;
    });
    t0.Products.forEach((p, idx) => {
      p.NumberOfPaidProductsVendedSinceInit = telemetry1.Products[idx].NumberOfPaidProductsVendedSinceInit - telemetry2.Products[idx].NumberOfPaidProductsVendedSinceInit;
      p.ValueOfPaidProductSalesSinceInit = telemetry1.Products[idx].ValueOfPaidProductSalesSinceInit - telemetry2.Products[idx].ValueOfPaidProductSalesSinceInit;
    });
    Object.keys(t0.AllValues).forEach((k) => {
      t0.AllValues[k] = telemetry1.AllValues[k] - telemetry2.AllValues[k];
    });
    return t0;
  }

  constructor(date, lines, device) {
    this.Date = date;
    this.DatePeriodStart = null;
    this.VendingMachine = {};
    this.AllValues = {};
    this.CoinMechanism = {};
    this.DecimalPoint = 0;
    this.Cashless1 = { Items: [] };
    /** @type {TelemetryIngredient[]} */
    this.Ingredients = [];
    /** @type {TelemetryProduct[]} */
    this.Products = [];
    this.PriceLists = [];
    this.AcceptedCoins = [];
    this.CoinTypes = [];
    var i = 0;
    while (i < lines.length) {
      var l = lines[i];
      var f = l.split("*");
      switch (f[0]) {
        case "DXS":
          this.SenderId = f[1];
          this.FunctionalIdentifier = f[2];
          this.Version = f[3];
          this.TransimissionControlNumber = f[4];
          this.CommunicationIdOfRecipient = f[5];
          break;

        case "ST":
          this.TransactionSetHeader = f[1];
          this.TransactionSetControlNumber = f[2];
          break;

        case "AM1":
          this.VendingMachine.AuditModuleCommsGatewaySerialNumber = f[1];
          this.VendingMachine.AuditModuleCommsGatewayModelNumber = f[2];
          this.VendingMachine.AuditModuleCommsGatewaySoftwareRevision = f[3];
          this.VendingMachine.AuditModuleCommsGatewayAssetNumber = f[4];
          break;

        case "AC1":
          this.VendingMachine.AuditModuleCommsGatewayAssetNumber = f[1];
          break;

        case "ID1":
          this.VendingMachine.SerialNumber = f[1];
          this.VendingMachine.ModelNumber = f[2];
          this.VendingMachine.BuildStandard = f[3];
          break;

        case "ID4":
          this.DecimalPoint = Number(f[1]);
          Telemetry.DecimalDivider = Number(1 + "".padEnd(this.DecimalPoint, "0"));
          if (f.length > 2) this.VendingMachine.CurrencyNumericCode = f[2];
          if (f.length > 3) this.VendingMachine.CurrencyAlphabeticCode = f[3];
          break;

        case "ID6":
          this.VendingMachine.CurrentCashBagNumber = f[1];
          break;

        case "CB1":
          this.VendingMachine.ControlBoardSerialNumber = f[1];
          this.VendingMachine.ControlBoardModelNumber = f[2];
          this.VendingMachine.ControlBoardSoftwareRevision = f[3];
          break;

        case "VA1":
          this.AllValues.PaidSalesValueSinceInit = Telemetry.setValue(f[1]);
          this.AllValues.PaidSalesCountSinceInit = Number(f[2]);
          this.AllValues.PaidSalesValueSinceReset = Telemetry.setValue(f[3]);
          this.AllValues.PaidSalesCountSinceReset = Number(f[4]);
          break;

        case "VA2":
          this.AllValues.TestPaidSalesValueSinceInit = Telemetry.setValue(f[1]);
          this.AllValues.TestPaidSalesCountSinceInit = Number(f[2]);
          this.AllValues.TestPaidSalesValueSinceReset = Telemetry.setValue(f[3]);
          this.AllValues.TestPaidSalesCountSinceReset = Number(f[4]);
          break;

        case "VA3":
          this.AllValues.FreeVendSalesValueSinceInit = Telemetry.setValue(f[1]);
          this.AllValues.FreeVendSalesCountSinceInit = Number(f[2]);
          this.AllValues.FreeVendSalesValueSinceReset = Telemetry.setValue(f[3]);
          this.AllValues.FreeVendSalesCountSinceReset = Number(f[4]);
          break;

        case "PA1":
          this.Products.push(new TelemetryProduct(this.Products.length, f, device));
          break;

        case "PA2":
          var cp2 = this.Products[this.Products.length - 1];
          cp2.NumberOfPaidProductsVendedSinceInit = Number(f[1]);
          cp2.ValueOfPaidProductSalesSinceInit = Number(f[2]);
          cp2.NumberOfPaidProductsVendedSinceLastReset = Number(f[3]);
          cp2.ValueOfPaidProductSalesSinceLastReset = Number(f[4]);
          cp2.NumberOfDiscountedPaidVendsSinceInit = Number(f[5]);
          cp2.ValueOfDiscountsgivenSinceInit = Number(f[6]);
          cp2.NumberOfDiscountedPaidVendsSinceLastReset = Number(f[7]);
          cp2.ValueOfDiscountsGivenSinceLastReset = Number(f[8]);
          break;

        case "PA3":
          var cp3 = this.Products[this.Products.length - 1];
          cp3.NumberOfTestVendsSinceInit = Number(f[1]);
          cp3.ValueOfTestVendsSinceInit = Number(f[2]);
          cp3.NumberOfTestVendsSinceLastReset = Number(f[3]);
          break;

        case "PA4":
          var cp4 = this.Products[this.Products.length - 1];
          cp4.NumberOfFreeVendsSinceInit = Number(f[1]);
          cp4.ValueOfFreeVendsSinceInit = Number(f[2]);
          cp4.NumberOfFreeVendsSinceLastReset = Number(f[3]);
          break;

        case "DA1":
          this.Cashless1.SerialNumber = f[1];
          this.Cashless1.ModelNumber = f[2];
          this.Cashless1.SoftwareRevision = f[3];
          break;

        case "DA2":
          this.Cashless1.ValueSinceInit = Telemetry.setValue(f[1]);
          this.Cashless1.NumberOfVendsSinceInit = Number(f[2]);
          this.Cashless1.ValueSinceLastReset = Telemetry.setValue(f[3]);
          this.Cashless1.NumberOfVendsSinceLastReset = Number(f[4]);
          break;

        case "DA4":
        case "DA5":
          break;

        case "DA7":
          this.Cashless1.Items.push(new TelemetryCashlessItem(f));
          break;

        case "SA2":
          this.Ingredients.push(new TelemetryIngredient(this.Ingredients.length, f, device));
          break;

        case "LA1":
          this.PriceLists.push(new TelemetryPriceList(f));
          break;

        case "CA1":
          this.CoinMechanism.SerialNumber = f[1];
          this.CoinMechanism.ModelNumber = f[2];
          this.CoinMechanism.SoftwareRevision = f[3];
          break;

        case "CA2":
          this.CoinMechanism.CashValueSinceInit = Telemetry.setValue(f[1]);
          this.CoinMechanism.CashVendsCountSinceInit = Number(f[2]);
          this.CoinMechanism.CashValueSinceReset = Telemetry.setValue(f[3]);
          this.CoinMechanism.CashVendsCountSinceReset = Number(f[4]);
          break;

        case "CA3":
          this.CoinMechanism.ValueOfCashInSinceLastReset = Telemetry.setValue(f[1]);
          this.CoinMechanism.ValueOfCashToCashBoxSinceLastReset = Telemetry.setValue(f[2]);
          this.CoinMechanism.ValueOfCashtoTubesSinceLastReset = Telemetry.setValue(f[3]);
          this.CoinMechanism.ValueOfBillsInSinceLastReset = Telemetry.setValue(f[4]);
          this.CoinMechanism.ValueOfCashInSinceInit = Telemetry.setValue(f[5]);
          this.CoinMechanism.ValueOfCashToCashBoxSinceInit = Telemetry.setValue(f[6]);
          this.CoinMechanism.ValueOfCashToTubesSinceInit = Telemetry.setValue(f[7]);
          this.CoinMechanism.ValueOfBillsInSinceInit = Telemetry.setValue(f[8]);
          this.CoinMechanism.ValueOfBillsInSinceLastReset = Telemetry.setValue(f[9]);
          this.CoinMechanism.ValueOfBillsInSinceInit = Telemetry.setValue(f[10]);
          break;

        case "CA4":
          this.CoinMechanism.ValueOfCashDispensedSinceLastReset = Telemetry.setValue(f[1]);
          this.CoinMechanism.ValueOfCashManuallyDispensedSinceLastReset = Telemetry.setValue(f[2]);
          this.CoinMechanism.ValueOfCashDispensedSinceInit = Telemetry.setValue(f[3]);
          this.CoinMechanism.ValueOfCashManuallyDispensedSinceInit = Telemetry.setValue(f[4]);
          break;

        case "CA7":
          this.CoinMechanism.ValueOfCashDiscountsSinceLastReset = Telemetry.setValue(f[1]);
          this.CoinMechanism.ValueOfCashDiscountsSinceInit = Telemetry.setValue(f[2]);
          break;

        case "CA8":
          this.CoinMechanism.ValueOfCashOverpaySinceLastReset = Telemetry.setValue(f[1]);
          this.CoinMechanism.ValueOfCashOverpaySinceInit = Telemetry.setValue(f[2]);
          break;

        case "CA10":
          this.CoinMechanism.ValueOfCashFilledSinceLastReset = Telemetry.setValue(f[1]);
          this.CoinMechanism.ValueOfCashFilledSinceInit = Telemetry.setValue(f[2]);
          break;

        case "CA11":
          this.AcceptedCoins.push(new TelemetryAcceptedCoins(f));
          break;

        case "CA15":
          this.CoinMechanism.ValueOfTubeContents = Telemetry.setValue(f[1]);
          break;

        case "CA17":
          this.CoinTypes.push(new TelemetryCoinTypes(f));
          break;

        default:
          break;
      }
      i++;
    }
  }
}
